import { ApolloClient } from '@apollo/client';
import logger from '../common/helpers/logger/logger';
import {
  HERO_VIDEO_QUERY,
  HeroVideoInfo,
  HeroVideoPostQueryRequest,
  HeroVideoPostQueryResponse,
} from '../queries/homePage/heroVideo';
import { PostSubcategory } from '../common/helpers/domain/postCategories';
import { PropertyType } from '../common/helpers/domain/propertyTypes';

interface FetchHeroVideoOptions {
  postCategory?: PostSubcategory[];
  propertyType?: PropertyType;
  tag?: string;
}
export async function fetchHeroVideo(
  client: ApolloClient<unknown>,
  options: FetchHeroVideoOptions,
): Promise<HeroVideoInfo | undefined> {
  try {
    logger.logInfo('heroVideoService.fetchHeroVideo', 'Begin', options);
    const response = await client.query<
      HeroVideoPostQueryResponse,
      HeroVideoPostQueryRequest
    >({
      query: HERO_VIDEO_QUERY,
      variables: {
        postCategory: options.postCategory,
        propertyType: options.propertyType,
        tag: options.tag,
      },
    });
    return response?.data?.heroVideo;
  } catch (error) {
    logger.logError(
      'heroVideoService.fetchHeroVideo',
      'Error retrieving from query.',
      error,
    );
    throw error;
  }
}
